import script from "./Debug.vue?vue&type=script&setup=true&lang=js"
export * from "./Debug.vue?vue&type=script&setup=true&lang=js"

import "./Debug.vue?vue&type=style&index=0&id=5a434295&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96/0/frontvue/main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a434295"]])

export default __exports__